import { render, staticRenderFns } from "./adminduk.vue?vue&type=template&id=672aa8d8"
import script from "./adminduk.vue?vue&type=script&lang=js"
export * from "./adminduk.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports